import { QueryConfig } from "store/utils/query-config";

export const supplierPaymentMethodsDefaultQueryConfig: QueryConfig = {
  query: {},
  options: {
    sortBy: ["createdAt"],
  },
};
